import styled from "styled-components";

export const AccordianCompStyle = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e2e2;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
